import { EmptyState, FlexColumn, FlexRow, FullContainer, Loading } from '@gorila-shared-ui/components';
import { Accordion, Panel } from 'baseui/accordion';
import { Pagination } from 'baseui/pagination';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { integrationsPageState, integrationsState, loadingIntegrationsState } from '../../../storage/integrations';
import { WS_TYPE } from '../../../utils/webServices';
import IntegrationsProvider from '../../providers/IntegationsProvider';
import IntegrationLogs from './IntegrationLogs';

function IntegrationsTab() {
  const { theme, css, classes, concatenateClasses } = useStyles();
  const [page, setPage] = useRecoilState(integrationsPageState);
  const integrations = useRecoilValue(integrationsState);
  const loading = useRecoilValue(loadingIntegrationsState);
  const totalItems = integrations?.total ?? 0;

  return (
    <FullContainer
      flexible
      classNames={css({
        boxSizing: 'border-box',
        flexDirection: 'column',
        padding: theme.sizing.scale600,
      })}
    >
      <IntegrationsProvider />
      <FlexColumn
        gap={0}
        classNames={css({
          flex: 1,
          overflow: 'hidden',
          [theme.mediaQuery.large]: {
            maxWidth: '60%',
          },
          [theme.mediaQuery.extraLarge]: {
            maxWidth: '50%',
          },
        })}
      >
        {!integrations && !loading && <EmptyState title="No cuentas con integraciones" />}
        {!integrations && loading && <Loading />}
        {integrations && (
          <>
            {!!integrations.items.length && (
              <>
                <FlexColumn classNames={concatenateClasses(classes.flexFill, css({ overflowY: 'auto' }))}>
                  <Accordion>
                    {integrations.items.map((integration) => (
                      <Panel
                        key={integration._id}
                        title={
                          <FlexRow
                            gap={theme.sizing.scale200}
                            classNames={classes.centeredStart}
                          >
                            <LabelMedium>{integration.name}</LabelMedium>
                            <ParagraphSmall
                              margin={0}
                              color={theme.colors.contentSecondary}
                            >
                              ({WS_TYPE[integration.wsType]})
                            </ParagraphSmall>
                          </FlexRow>
                        }
                        overrides={{
                          Content: {
                            style: {
                              paddingTop: 0,
                            },
                          },
                        }}
                      >
                        <IntegrationLogs integrationId={integration._id} />
                      </Panel>
                    ))}
                  </Accordion>
                </FlexColumn>
                {totalItems > 50 && (
                  <FlexRow classNames={classes.centeredEnd}>
                    <Pagination
                      labels={{
                        nextButton: 'Siguiente',
                        preposition: 'de',
                        prevButton: 'Anterior',
                      }}
                      size="compact"
                      currentPage={page > 0 ? page : 1}
                      numPages={Math.ceil(totalItems / 50)}
                      onPageChange={({ nextPage }) => setPage(nextPage)}
                    />
                  </FlexRow>
                )}
              </>
            )}
            {!integrations.items.length && <EmptyState title="No cuentas con integraciones" />}
          </>
        )}
      </FlexColumn>
    </FullContainer>
  );
}

export default IntegrationsTab;
